import { useRef, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import axios from "../api/axiosBaseURL";
const LOGIN_URL = "/login";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const userRef = useRef();
  const errorRef = useRef();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const APP_PATH = process.env.REACT_APP_CONTEXT_PATH;

  useEffect(() => {
    userRef.current.focus();
  }, []);

  useEffect(() => {
    setErrorMessage("");
  }, [username, password]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios
        .post(LOGIN_URL, JSON.stringify({ username, password }), {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        })
        .then((response) => {
          const token = JSON.stringify(response.data.token);
          localStorage.setItem("token", token);
          setUsername("");
          setPassword("");
          const t = localStorage.getItem("token");
        })
        .then((response) => {
          navigate((window.location.href = APP_PATH + "/"));
        });
    } catch (error) {
      if (!error?.response) {
        setErrorMessage("No Response from Server");
      } else if (error.response?.status === 401) {
        setErrorMessage("CREDENTIALS ARE NOT VALID");
      } else {
        setErrorMessage("Something is wrong");
      }
      errorRef.current.focus();
    }
  };

  return (
    <div className="login-form">
      <img src={`${APP_PATH}/splash-logo.svg`} alt="" />
      <div className="login-form-content">
        <h4>Sign in</h4>
        <form onSubmit={handleSubmit}>
          <label htmlFor="username">Username:</label>
          <input
            className="form-control"
            type="text"
            id="username"
            ref={userRef}
            autoComplete="off"
            onChange={(e) => setUsername(e.target.value)}
            value={username}
            required
          />

          <label htmlFor="password">Password:</label>
          <input
            className="form-control"
            type="password"
            id="password"
            onChange={(e) => setPassword(e.target.value)}
            value={password}
            required
          />
          <p
            ref={errorRef}
            className={errorMessage ? "errmsg" : "offscreen"}
            aria-live="assertive"
          >
            {errorMessage}
          </p>
          <button className="large-button green">SIGN IN</button>
        </form>
        <br />
        <span className="line">
          <a target="_blank" href="https://amalgamasimulation.com/">
            amalgamasimulation.com
          </a>
        </span>
      </div>
    </div>
  );
};

export default Login;
